import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import { HiChevronDown, HiChevronUp } from "react-icons/hi";
import apiService from "../../../Services/authenticationServices";
import { useCheOrders } from "./CheOrders";
import { toast } from "react-toastify";
import b2bService from "../../../Services/b2bServises";
import { convertUTCDate } from "../../../Utils/utilServices";
import { HiDownload, HiX } from "react-icons/hi";
import { convertAmountToWords } from "../../../Utils/utilServices";
import CureBaylogo from "../../../Assets/CurebayLogo.svg";
import bulkOrderIcon from '../../../Assets/BulkOrder.png'
import ShipmentBarcode from "../../ShipmentBarcode"
import { fmtDateTime } from "../../../Utils/dateFormat";



const InvoiceModal = ({ isOpen, onClose, orderData, orderDetails }) => {
  if (!isOpen || !orderData) return null;

  const totalAmount = orderDetails?.reduce(
    (sum, item) => sum + item.unitPrice * item.quantity,
    0
  ) || 0;

  const discount = totalAmount - orderData.paidAmount;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${date.toLocaleDateString("en-GB")} ${date.toLocaleTimeString()}`;
  };

  const formatAddress = (address1, address2, city, state, pinCode) => {
    return [address1, address2, city, state, pinCode].filter(Boolean).join(", ");
  };

  const amountInWords = orderData.paidAmount > 0
    ? `(${convertAmountToWords(orderData.paidAmount)})`
    : "";




  const downloadInvoice = () => {
    const printContents = document.getElementById('invoice-content').innerHTML;
    printDiv(printContents);
  };

  const printDiv = (div) => {
    let popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.write(`
      <html>
        <head>
          <title>Invoice #${orderData.orderId}</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 20px;
              color: #333;
              line-height: 1.5;
            }
            .invoice-container {
              max-width: 800px;
              margin: 0 auto;
            }
            .header {
              text-align: center;
              margin-bottom: 20px;
            }
            .header h1 {
              font-size: 24px;
              margin-bottom: 10px;
            }
            .patient-info {
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;
            }
            .patient-info-col {
              width: 48%;
            }
            .info-label {
              font-weight: bold;
              margin-bottom: 5px;
            }
            .info-value {
              margin-bottom: 10px;
            }
            .address {
              margin-bottom: 20px;
            }
            hr {
              border: 0;
              border-top: 1px solid #ddd;
              margin: 20px 0;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
            }
            th, td {
              border: 1px solid #ddd;
              padding: 8px;
              text-align: left;
            }
            th {
              background-color: #f6f5f1;
              font-weight: bold;
            }
            .total-row {
              font-weight: bold;
            }
            .amount-in-words {
              font-style: italic;
              text-align: right;
              margin-top: 5px;
            }
            .d-print-none {
              display: none;
            }
          </style>
        </head>
        <body>
          <div class="invoice-container">
            ${div}
          </div>
        </body>
      </html>
    `);
    popupWin.document.close();
    popupWin.focus();
    setTimeout(function () {
      popupWin.print();
      popupWin.close();
    }, 500);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-2 sm:p-4">
      <div id="invoice-content" className="bg-white rounded-lg p-4 sm:p-8 w-full max-w-7xl relative overflow-scroll max-h-[90vh] print-content">

        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-black text-2xl d-print-none"
        >
          <HiX />
        </button>

        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="text-2xl font-bold">Order Invoice</h2>
          </div>
          <img
            src={CureBaylogo}
            alt="CureBay Logo"
            className="h-8"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm mb-4">
          <div>
            <p className="text-gray-600">Patient</p>
            <p className="font-semibold">
              {orderData.patientName}/{orderData.patientGender}/
              {orderData.patientAge} Years ({orderData.patientId})
            </p>
          </div>
          <div>
            <p className="text-gray-600">Mobile</p>
            <p className="font-semibold">{orderData.patientMobile}</p>
          </div>
          <div>
            <p className="text-gray-600">Order ID</p>
            <p className="font-semibold">{orderData.orderId}</p>
          </div>
          <div>
            <p className="text-gray-600">Ordered Date</p>
            <p className="font-semibold">{fmtDateTime(orderData.modifiedDate, { zone: "utc-local" })}</p>
          </div>
          <div>
            <p className="text-gray-600">Transaction ID</p>
            <p className="font-semibold">{orderData.refTxnId}</p>
          </div>
        </div>
        <div className="mb-4">
          <p className="text-gray-600 text-sm">Address</p>
          <p className="font-semibold text-sm">
            {formatAddress(
              orderData.address1,
              orderData.address2,
              orderData.patientCityBook,
              orderData.patientStateBook,
              orderData.patientPinCodeBook
            )}
          </p>
        </div>

        <hr className="my-4" />

        <div className="overflow-x-auto text-sm mb-6">
          <table className="min-w-full border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                {[
                  "Transaction Type",
                  "Transaction ID",
                  "Payable Amount",
                  "Date Of Payment",
                  "Payment Mode",
                  "Service Provider/Doctor",
                  "Discount Amount",
                ].map((header, idx) => (
                  <th key={idx} className="p-2 text-left border">
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="p-2 border">{orderData?.serviceName}</td>
                <td className="p-2 border">{orderData.refTxnId}</td>
                <td className="p-2 border">₹{orderData.paidAmount?.toFixed(2)}</td>
                <td className="p-2 border">{fmtDateTime(orderData.paymentDateTime, { zone: "utc-local" })}</td>
                <td className="p-2 border">{orderData.payMode || "Cash"}</td>
                <td className="p-2 border">{orderData.hospitalName}</td>
                <td className="p-2 border">₹{discount.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="font-bold text-lg mb-2">Pharmacy Order Breakup</h3>
        <div className="overflow-x-auto text-sm mb-6">
          <table className="min-w-full border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 text-left border">Prescription Order</th>
                <th className="p-2 text-left border">Quantity</th>
                <th className="p-2 text-left border">Unit Price</th>
                <th className="p-2 text-left border">Total Amount (INR)</th>
              </tr>
            </thead>
            <tbody>
              {orderDetails?.map((item, index) => (
                <tr key={index}>
                  <td className="p-2 border">{item.drugName}</td>
                  <td className="p-2 border">{item.quantity}</td>
                  <td className="p-2 border">₹{item.unitPrice?.toFixed(2)}</td>
                  <td className="p-2 border">
                    ₹{(item.quantity * item.unitPrice)?.toFixed(2)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex justify-end">
          <div className="w-full md:w-1/2 text-sm">
            <div className="flex justify-between mb-2 font-semibold">
              <span>Total (INR):</span>
              <span>₹{totalAmount.toFixed(2)}</span>
            </div>
            <div className="flex justify-between mb-2 font-semibold">
              <span>CureBay Discount (INR):</span>
              <span>₹{discount.toFixed(2)}</span>
            </div>
            <div className="flex justify-between text-lg font-bold border-t pt-2">
              <span>Payable Amount (INR):</span>
              <span>₹{orderData.paidAmount?.toFixed(2)}</span>
            </div>
            <p className="text-right italic text-xs text-gray-600 mt-1">
              {amountInWords}
            </p>
          </div>
        </div>

        <div className="flex justify-end mt-6 space-x-3 d-print-none">
          <button
            onClick={downloadInvoice}
            className="flex items-center gap-2 border border-blue-500 text-blue-600 px-4 py-2 rounded hover:bg-blue-100"
          >
            <HiDownload />
            Download
          </button>
          <button
            onClick={onClose}
            className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};




const OrderHeaderAccordion = ({
  data,
  index,
  isOpen,
  onToggle,
  selectedItems,
  onSelectItem,
  onClose
}) => {
  const scrollRef = useRef(null);
  const bgColor = index % 2 === 0 ? "bg-[#f6f5f1]" : "bg-[#FFFFFF]";
  const [orderDetails, setOrderDetails] = useState([]);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [selectedConsignment, setSelectedConsignment] = useState(null);

  const slaList = [
    { name: '0 -12 Hours', value: 1 },
    { name: '12-24 Hours', value: 2 },
    { name: '24-36 Hours', value: 3 },
    { name: '36-48 Hours', value: 4 },
    { name: '48-60 Hours', value: 5 },
    { name: '60-72 Hours', value: 6 },
    { name: '72 Hrs-1 Week', value: 7 },
    { name: 'Cannot be supplied', value: 8 },
    { name: 'CureBay Preferred Medicine ', value: 9 },
  ];

  const columns = [
    { field: 'checkBox', header: '' },
    { field: 'drugName', header: 'Drug Name' },
    { field: 'drugCode', header: 'Drug Code' },
    { field: 'fulfillmentStatus', header: 'Status' },
    { field: 'sentToSaveo', header: 'Order Processing Via' },
    { field: 'drugsInfoComposition', header: 'Composition & Strength' },
    { field: 'drugsInfoTypeofsell', header: 'Package Size' },
    { field: 'quantity', header: 'Quantity' },
    { field: 'unitPrice', header: 'Unit Price' },
    { field: 'actualPrice', header: 'Payable Amount' },
    { field: 'consignmentStatus', header: 'Pdt.Status' },
    { field: 'deliverySlaStatus', header: 'SLA' },
    { field: 'deliverySlaTime', header: 'Committed ETA' },
    { field: 'deliverySlaETATime', header: 'ETA' },
    { field: 'consignmentId', header: 'Consignment ID' },
  ];

  const pdtStatuses = [
    { name: 'Yet to Packed', value: 0 },
    { name: 'Packed', value: 1 },
    { name: 'Shipped', value: 2 },
    { name: 'Order on the Bus', value: 3 },
    { name: 'Out for Delivery', value: 4 },
    { name: 'Delivered', value: 5 }
  ];

  const getStatusName = (value) => {
    const status = pdtStatuses.find(item => item.value === value);
    return status ? status.name : 'Yet to Packed';
  };

  const getSlaName = (value) => {
    const slaItem = slaList.find(item => item.value === value || '');
    return slaItem?.name ?? ''
  };

  const formatAddress = (...parts) => parts.filter(Boolean).join(", ");

  const fetchData = async () => {
    try {
      const payload = {
        patientDrugPrescriptionOrderId: data.orderId,
        status: 1,
      };
      const response = await apiService.getOrderDetails(payload);
      setOrderDetails(response.data.successList || []);
    } catch (err) {
      toast.error("An error occurred while fetching order details.");
    }
  };

  const copyConfirmTab = (item, index) => {
    const newOrderDetails = [...orderDetails];
    const copiedItem = { ...newOrderDetails[index] };

    newOrderDetails[index].disabled = true;
    newOrderDetails[index].copiedFrom = 'Y';

    copiedItem.id = null;
    copiedItem.copiedqty = copiedItem.quantity;
    copiedItem.quantity = 0;
    copiedItem.copiedindex = index;
    copiedItem.disabled = false;
    copiedItem.copiedFrom = 'N';
    newOrderDetails.push(copiedItem);
    setOrderDetails(newOrderDetails);
  };

  const handleQuantityChange = (item, value, index) => {
    const numericValue = parseInt(value) || 0;
    const originalIndex = item.copiedindex;

    const originalItem = orderDetails[originalIndex];

    if (!originalItem) {
      setOrderDetails(prev => {
        const newDetails = [...prev];
        newDetails[index].quantity = numericValue;
        newDetails[index].actualPrice = numericValue * (item.unitPrice || item.modifiedTotalAmount / item.quantity);
        return newDetails;
      });
      return;
    }

    if (numericValue > item.copiedqty) {
      toast.error('Split Qty greater than actual Qty');

      setOrderDetails(prev => {
        const newDetails = [...prev];
        newDetails[index].quantity = 0;
        newDetails[index].actualPrice = 0;

        newDetails[originalIndex].quantity = item.copiedqty;
        newDetails[originalIndex].actualPrice =
          item.copiedqty * (originalItem.unitPrice || originalItem.modifiedTotalAmount / originalItem.quantity);

        return newDetails;
      });
      return;
    }

    setOrderDetails(prev => {
      const newDetails = [...prev];

      newDetails[index].quantity = numericValue;
      newDetails[index].actualPrice = numericValue * (item.unitPrice || item.modifiedTotalAmount / item.quantity);

      newDetails[originalIndex].quantity = item.copiedqty - numericValue;
      newDetails[originalIndex].actualPrice =
        (item.copiedqty - numericValue) * (originalItem.unitPrice || originalItem.modifiedTotalAmount / originalItem.quantity);

      return newDetails;
    });
  };

  const saveChanges = async () => {
    try {
      const response = await apiService.updateOrderDetails(orderDetails);
      if (response.data.responseCode === '200') {
        toast.success('Changes saved successfully');
        fetchData();
      } else {
        toast.error(response.data.message || 'Failed to save changes');
      }
    } catch (err) {
      console.error(err);
      toast.error('Failed to save changes');
    }
  };

  const isMedsNow = (data.shipments || []).some(
    (sh) => sh?.shipmentType === "EXPRESS_30"
  );

  const headerFields = [
    { label: "Order Date", value: fmtDateTime(data.modifiedDate), width: "sm:w-[12%]" },
    { label: "Order ID", value: data.orderId, width: "sm:w-[12%]" },
    { label: "Patient ID", value: data.patientId, width: "sm:w-[12%]" },
    { label: "Patient Name", value: data.patientName, width: "sm:w-[12%]" },
    { label: "Mobile No.", value: data.patientMobile, width: "sm:w-[12%]" },
    {
      label: "Patient Address",
      value: formatAddress(data.address1, data.address2, data.address3),
      width: "sm:w-[20%]",
    },
    { label: "Eclinic", value: data.cheBranchName, width: "sm:w-[10%]" },
    {
      label: "Eclinic Address",
      value: formatAddress(
        data.deliveryAddress1,
        data.deliveryAddress2,
        data.deliveryAddress3
      ),
      width: "sm:w-[20%]",
    },
    { label: "Amount", value: data.paidAmount, width: "sm:w-[8%]" },
  ];

  const handleItemSelect = (item, isChecked) => {
    onSelectItem(item, isChecked, data.orderId);
  };

  /* A row can be selected only once it is invoiced and has no consignment yet. */
  const isItemSelectable = (item) =>
    String(item.statusDesc || '').trim() === 'Invoiced' && !item.consignmentId;

  const isItemSelected = (item) =>
    selectedItems.some(
      (selected) => selected.orderId === data.orderId && selected.itemId === item.id
    );

  const selectableItems = orderDetails.filter(isItemSelectable);
  const allSelectableSelected =
    selectableItems.length > 0 && selectableItems.every(isItemSelected);

  /* Header checkbox: toggle every enabled (selectable) row in this order. */
  const handleSelectAll = (isChecked) => {
    selectableItems.forEach((item) => {
      const selected = isItemSelected(item);
      if (isChecked && !selected) handleItemSelect(item, true);
      else if (!isChecked && selected) handleItemSelect(item, false);
    });
  };

  useEffect(() => {
    if (isOpen) {
      scrollRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      fetchData();
    }
  }, [isOpen, data.orderId]);

  return (
    <div ref={scrollRef} className={`relative border rounded ${bgColor} my-3`}>
      {isMedsNow && (
        <span className="absolute top-0 left-0 z-10 px-2 py-0.5 rounded-tl rounded-br bg-[#336b3b] text-white text-[10px] font-bold tracking-wide">
          MEDS NOW
        </span>
      )}
      <div
        onClick={onToggle}
        className="cursor-pointer px-2 sm:px-4 flex justify-between items-center"
      >
        <div className={`flex-1 sm:flex-initial min-w-0 flex flex-wrap sm:flex-nowrap overflow-auto text-xs p-2 sm:p-4 gap-x-3 gap-y-2 sm:gap-5 ${isMedsNow ? "pt-6 sm:pt-6" : ""}`}>
          {headerFields.map(({ label, value, width }, i) => (
            <span key={i} className={`w-[calc(50%-6px)] ${width} break-words`}>
              <span className="text-gray-500">{label}:</span> {value}
            </span>
          ))}
        </div>
        <span className="text-gray-600 text-xl">
          {isOpen ? <HiChevronUp /> : <HiChevronDown />}
        </span>
      </div>

      {isOpen && <div className="h-[1px] bg-gray-300 w-full" />}

      {isOpen && (
        <div className="p-4 pb-8 bg-white overflow-auto">
          <div className="flex flex-wrap sm:flex-nowrap overflow-auto gap-4 mb-4 text-sm">
            {data.defaultSla && (
              <div className="w-full sm:w-[15%] break-words">
                <p className="text-gray-500">
                  Delivery SLA: <span> {getStatusName(data.defaultSla)}</span>
                </p>
              </div>
            )}
            {data.shipTo && (
              <div className="w-full sm:w-[15%] break-words">
                <p className="text-gray-500">
                  Ship To: <span>{data.shipTo}</span>
                </p>
              </div>
            )}
            {data.shippingName && (
              <div className="w-full sm:w-[20%] break-words">
                <p className="text-gray-500">
                  Shipping Name: <span>{data.shippingName}</span>
                </p>
              </div>
            )}
            {data.shippingAddress && (
              <div className="w-full sm:w-[50%] break-words">
                <p className="text-gray-500">
                  Shipping Address: <span>{data.shippingAddress}</span>
                </p>
              </div>
            )}
          </div>

          <div className="flex flex-wrap justify-between gap-2 mb-3">
            <div className="flex items-center gap-3">
              <button
                className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md"
                onClick={() => setShowInvoiceModal(true)}
              >
                Open Invoice
              </button>
              {isMedsNow && (
                <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-[#336b3b] text-white text-[11px] font-bold tracking-wide">
                  <span className="h-1.5 w-1.5 rounded-full bg-white" />
                  MEDS NOW
                </span>
              )}
            </div>
            <div className="flex flex-wrap items-center gap-6">
              {data.bulkOrderFlag === "Y" ? (
                <div className="flex items-center text-[#2e4373] font-medium">
                  <img
                    src={bulkOrderIcon}
                    alt="Bulk Order Icon"
                    className="h-6 w-6 mr-1"
                  />
                  Marked as Bulk Order
                </div>
              ) : ""}

              <button
                className="bg-[#336b3b] text-white px-4 py-2 rounded-md"
                onClick={saveChanges}
              >
                Save Changes
              </button>
            </div>
          </div>

          <div className="overflow-x-auto border border-[#1d2f5b] rounded-md">
            <div className="min-w-full inline-block align-middle">
              <div className="overflow-x-auto">
                <table className="min-w-full text-sm text-left">
                  <thead className="bg-[#1d2f5b] text-white">
                    <tr>
                      {columns.map((column, index) => (
                        <th key={index} className="p-2 font-semibold">
                          {column.field === 'checkBox' ? (
                            <input
                              type="checkbox"
                              checked={allSelectableSelected}
                              onChange={(e) => handleSelectAll(e.target.checked)}
                              disabled={selectableItems.length === 0}
                              title="Select all invoiced items"
                            />
                          ) : (
                            column.header
                          )}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {orderDetails.map((item, index) => (
                      <tr key={item.id || index} className="border-t">
                        {columns.map((column) => {
                          if (column.field === 'checkBox') {
                            return (
                              <td key={column.field} className="p-2 whitespace-nowrap">
                                <input
                                  type="checkbox"
                                  checked={isItemSelected(item)}
                                  onChange={(e) => handleItemSelect(item, e.target.checked)}
                                  disabled={!isItemSelectable(item)}
                                />
                              </td>
                            );
                          }
                          else if (column.field === 'fulfillmentStatus') {
                            const desc = String(item.statusDesc || '').trim();
                            const cfg = desc === 'Invoiced'
                              ? { label: 'Invoiced', bg: 'bg-green-100', fg: 'text-green-800' }
                              : desc === 'Allocated'
                                ? { label: 'Allocated', bg: 'bg-amber-100', fg: 'text-amber-800' }
                                : { label: 'Unfulfilled', bg: 'bg-red-100', fg: 'text-red-800' };
                            return (
                              <td key={column.field} className="p-2 whitespace-nowrap">
                                <span className={`inline-block px-2 py-0.5 rounded text-xs font-semibold ${cfg.bg} ${cfg.fg}`}>
                                  {cfg.label}
                                </span>
                              </td>
                            );
                          }
                          else if (column.field === 'deliverySlaStatus') {
                            return (
                              <td key={column.field} className="p-2 whitespace-nowrap">
                                {getSlaName(item.deliverySlaStatus ?? item.defaultSla)}
                              </td>
                            );
                          }
                          else if (column.field === 'deliverySlaETATime') {
                            const slaColor =
                              item.deliverySlaColourStatus === 2 ? 'green' :
                                item.deliverySlaColourStatus === 1 ? 'red' :
                                  '';

                            const style = {
                              color: slaColor,
                              fontWeight: 'bold'
                            };

                            return (
                              <td key={column.field} className="p-2 whitespace-nowrap" style={style}>
                                {item[column.field]}
                              </td>
                            );
                          } else if (column.field === 'consignmentStatus') {
                            return (
                              <td key={column.field} className="p-2 whitespace-nowrap">
                                {getStatusName(item[column.field])}
                              </td>
                            );
                          }
                          else if (column.field === 'quantity') {
                            return (
                              <td>
                                <input
                                  type="text"
                                  value={item.quantity}
                                  onChange={(e) => {
                                    const val = Math.max(0, parseInt(e.target.value) || 0);
                                    handleQuantityChange(item, val, index);
                                  }}
                                  className="w-20 border rounded px-2 py-1"
                                  min="0"
                                  disabled={item.id}
                                />
                              </td>
                            );
                          } else if (column.field === 'sentToSaveo') {
                            return (
                              <td key={column.field} className="p-2 whitespace-nowrap">
                                {item.sentToSaveo === 1 ? 'Saveo' : 'Manual'}
                              </td>
                            );
                          } else if (column.field === 'consignmentId') {
                            return (
                              <td key={column.field} className="p-2 whitespace-nowrap">
                                {item[column.field] ? (
                                  <button
                                    type="button"
                                    className="text-blue-600 hover:underline"
                                    onClick={() => setSelectedConsignment(item[column.field])}
                                  >
                                    {item[column.field]}
                                  </button>
                                ) : (
                                  "-"
                                )}
                              </td>
                            );
                          } else {
                            return (
                              <td key={column.field} className="p-2 whitespace-nowrap">
                                {item[column.field] || '-'}
                              </td>
                            );
                          }
                        })}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      <InvoiceModal
        isOpen={showInvoiceModal}
        onClose={() => setShowInvoiceModal(false)}
        orderData={data}
        orderDetails={orderDetails}
      />
      <ShipmentBarcode
        isOpen={!!selectedConsignment}
        consignmentId={selectedConsignment}
        onClose={() => setSelectedConsignment(null)}
      />
    </div>
  );
};

const CheConfirmed = forwardRef((props, ref) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [orders, setOrders] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [isConsignmentMode, setIsConsignmentMode] = useState(false);
  const [useAltrack, setUseAltrack] = useState(true);
  const [sortOrder, setSortOrder] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasNextPage, setHasNextPage] = useState(true);
  const { filter, setFilterField } = useCheOrders();

  const handleSelectItem = (item, isChecked, orderId) => {
    if (isChecked) {
      setSelectedItems(prev => [
        ...prev,
        {
          orderId: orderId,
          orderDetailsId: item.id,
          modifiedBy: localStorage.getItem('userCode'),
          itemId: item.id,
          drugCode: item.drugCode,
          quantity: item.quantity
        }
      ]);
    } else {
      setSelectedItems(prev =>
        prev.filter(selected =>
          !(selected.orderId === orderId && selected.itemId === item.id)
        )
      );
    }
  };

  /* Only the latest list request may update the screen — an older, slower one
     finishing last would otherwise show results for filters no longer set. */
  const latestFetch = useRef(0);
  const fetchData = async (pageNo = 1) => {
    const seq = ++latestFetch.current;
    try {
      let payload = {
        procedureStatus: -2,
        pageNumber: pageNo,
        orderBy: sortOrder === 0 ? 'ASC' : 'DESC',
        conStatus: 1,
        ...Object.fromEntries(
          Object.entries(filter).filter(
            ([_, val]) => val !== null && val !== undefined && val !== ""
          )
        ),
      };
      /* Either date alone is a valid filter (the API treats it as that one day),
         so convert each one that is set, not only a complete range. */
      if (payload.fromDate) payload.fromDate = convertUTCDate(payload.fromDate);
      if (payload.toDate) payload.toDate = convertUTCDate(payload.toDate);
      const response = await apiService.getmedicineOrders(payload);
      if (seq !== latestFetch.current) return;
      let orderList = response.data.successList || [];

      setOrders(orderList);
      setCurrentPage(pageNo);
      setHasNextPage(orderList.length > 0);
    } catch (err) {
      if (seq !== latestFetch.current) return;
      console.error("Failed to fetch orders", err);
      setOrders([]);
      setHasNextPage(false);
      toast.error("Failed to fetch orders");
    }
  };

  const handleCreateConsignment = async () => {
    if (selectedItems.length === 0) {
      toast.error("Please select at least one item to create consignment");
      return;
    }

    try {
      const response = await b2bService.createConsignment(
        selectedItems,
        'CHE',
        useAltrack ? false : undefined
      );

      if (response.responseCode === '200') {
        toast.success('Consignment created successfully.');
        const vendor = vendorForItems(selectedItems);
        setSelectedItems([]);
        const consignmentId = response.successObject?.consignmentId;
        if (useAltrack && consignmentId) {
          packConsignment(consignmentId, vendor);
        } else {
          refreshOrders();
        }
      } else {
        toast.error(response.responseMessage || "Failed to create consignment");
      }
    } catch (error) {
      console.error("Consignment creation error:", error);
      toast.error("Failed to create consignment");
    }
  };

  const refreshOrders = () => {
    fetchData(currentPage);
    let x = openIndex
    setOpenIndex(null)
    setTimeout(() => {
      setOpenIndex(x)
    }, 500);
  };


  const vendorForItems = (items) => {
    const ids = new Set(items.map((i) => String(i.orderId)));
    const isExpress = orders
      .filter((o) => ids.has(String(o.orderId)))
      .some((o) => (o.shipments || []).some((sh) => sh?.shipmentType === 'EXPRESS_30'));
    return isExpress ? 'EAGLE' : 'ALLTRAK';
  };

  const packConsignment = async (consignmentId, useVendor = 'ALLTRAK') => {
    if (!consignmentId) {
      toast.error('Please select consignment id');
      return;
    }

    let user = JSON.parse(localStorage.getItem('loginObj'));
    let payload = {
      "consignmentId": consignmentId,
      "statusName": "PACKED",
      "userName": user.salutation + user.firstName + user.lastName,
      "userId": localStorage.getItem('userCode'),
      "createdBy": localStorage.getItem('userCode'),
      "modifiedBy": localStorage.getItem('userCode'),
      "status": "1",
      "source": 'B2B2C',
      "useVendor": useVendor
    };

    try {
      const response = await b2bService.packConsignment(payload);
      if (response.responseCode == '200') {
        toast.success('Status Updatated Successfully.');
        refreshOrders();
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      console.error("Packing error:", error);
      toast.error("Failed to pack consignment");
    }
  };

  const handleNextPage = () => {
    fetchData(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      fetchData(currentPage - 1);
    }
  };

  useEffect(() => {
    fetchData(1);
  }, [filter, sortOrder]);

  useImperativeHandle(ref, () => ({
    onSearch: () => fetchData(1),
  }));

  const handleToggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const handleSortChange = (value) => {
    setSortOrder(value);
  };

  return (
    <div className="pl-1 pr-1 sm:pr-6 min-h-screen">
      <div className="flex flex-wrap items-center gap-4 ml-4 mb-4">
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="sortOrder"
            value="newest"
            checked={sortOrder === 1}
            onChange={() => handleSortChange(1)}
            className="h-4 w-4 text-blue-600"
          />
          <span>Newest First</span>
        </label>
        <label className="flex items-center gap-2">
          <input
            type="radio"
            name="sortOrder"
            value="oldest"
            checked={sortOrder === 0}
            onChange={() => handleSortChange(0)}
            className="h-4 w-4 text-blue-600"
          />
          <span>Oldest First</span>
        </label>
      </div>

      <div className="flex flex-wrap justify-end items-center mb-3 gap-4">
        <label className="flex items-center gap-2 cursor-pointer select-none">
          <span className="text-sm text-gray-700">Use Altrack</span>
          <button
            type="button"
            role="switch"
            aria-checked={useAltrack}
            onClick={() => setUseAltrack((prev) => !prev)}
            className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ${useAltrack ? 'bg-[#336b3b]' : 'bg-gray-300'}`}
          >
            <span
              className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ${useAltrack ? 'translate-x-6' : 'translate-x-1'}`}
            />
          </button>
        </label>
        <button
          className="bg-[#336b3b] hover:bg-[#336b3b] text-white px-4 py-2 rounded-md transition-colors duration-200 flex items-center gap-1"
          onClick={handleCreateConsignment}
          disabled={selectedItems.length === 0}
        >
          Create Consignment
          {selectedItems.length > 0 && (
            <span className="bg-white text-[#336b3b] rounded-full w-5 h-5 flex items-center justify-center text-xs ml-1">
              {selectedItems.length}
            </span>
          )}
        </button>
      </div>

      {orders.map((order, index) => (
        <OrderHeaderAccordion
          key={index}
          data={order}
          index={index}
          isOpen={openIndex === index}
          onToggle={() => handleToggle(index)}
          selectedItems={selectedItems}
          onSelectItem={handleSelectItem}
          isConsignmentMode={isConsignmentMode}
          onClose={fetchData}
        />
      ))}

      <div className="flex flex-wrap justify-center items-center mt-4 mb-8 gap-2">
        <button
          onClick={handlePrevPage}
          disabled={currentPage === 1}
          className="px-4 py-2 border rounded disabled:opacity-50"
        >
          Previous
        </button>

        <button
          onClick={() => fetchData(1)}
          className={`px-4 py-2 border rounded ${currentPage === 1 ? 'bg-blue-100' : ''}`}
        >
          1
        </button>

        {currentPage > 1 && (
          <button
            onClick={() => fetchData(currentPage)}
            className="px-4 py-2 border rounded bg-blue-100"
          >
            {currentPage}
          </button>
        )}

        <button
          onClick={handleNextPage}
          disabled={!hasNextPage}
          className="px-4 py-2 border rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
});

export default CheConfirmed;